<template lang="pug">
  CommonLoadBox(:loaded="loaded")
    template(slot='skeleton')
      VideoRedPacketSkeleton
    template(slot='module')
      .video-red-packet-container(v-if="taskList && taskList.length > 0" v-platform-expose="moduleExpose")
        .video-red-packet-header
          .header-left
            .video-red-packet-title {{ moduleConfig.mainTitle }}
            //- 图标 + 副标题（富文本），subtitleLogoSwitch 控制图标渲染
            .video-red-packet-desc
              img.bounty-icon(
                v-if="moduleConfig.subtitleLogoSwitch && moduleConfig.subtitleLogo"
                :src="moduleConfig.subtitleLogo"
              )
              HighlightText.bounty-desc(
                v-if="moduleConfig.subtitle"
                :text="moduleConfig.subtitle"
                :normalStyle="subtitleNormalStyle"
                :highlightStyle="subtitleHighlightStyle"
              )
          .header-right
            .video-red-packet-btn(
              :class="{ 'video-red-packet-btn-disabled': !hasActive }"
              @click="handleMainBtnClick"
            ) {{ btnName }}
        .header-subTitle {{subTitle}}
        .video-red-packet-content(ref="videoRedPacketList")
          template(v-for="(item, index) in taskList")
            .video-red-packet-item(
              ref="videoRedPacketItem"
              :class="{ 'active': item.curActive, 'disabled': item.finished }"
              @click="handleItemClick(item)"
            )
              .video-red-packet-item-num(v-if="!item.finished") {{ item.amountText }}
</template>

<script>
import eventBus from '@/const/eventBus';
import { HighlightText } from '@hb/platformui-h5';
import { SUBTITLE_NORMAL_STYLE, SUBTITLE_HIGHLIGHT_STYLE } from '../../consts';
import { getPureSignPopup } from '@/api/fuli';
import { getTokenAndKey, scrollToLeft } from '@/utils';
import { ParamsUtil } from '@/utils/params';
import { safeJsonStringify } from '@/utils/tools';
import Toast from '@/components/toast';
import Loading from '@/components/loading';
import CommonLoadBox from '@/components/common-load-box';
import SPM from '../../common/spm';
import {
  loadPlatformAds,
  showPlatformAds,
  getManufacturer,
} from '../../common/bridge';
import {
  processAdParams,
  videoRedPacketDataAdapter,
  handleFinishTask,
  loadRewardResultPlatformAds,
} from '../../common/helper';
import { playContinuousVideo } from '../../common/continuous-video-engine';
import VideoRedPacketSkeleton from '../cpns-skeleton/video-red-packet-skeleton';
import { RED_PACKET_AB, ADV_SCENE } from '../../consts.js';
import {
  trackRewardPopupExpose,
  trackNextVideo,
  trackAdvClick,
  trackPopupClose,
} from '../../common/video-spm';

export default {
  name: 'VideoRedPacket',
  components: {
    CommonLoadBox,
    VideoRedPacketSkeleton,
    HighlightText,
  },
  props: {
    // 模块信息
    signInModuleInfo: {
      type: Array,
      default: () => null,
    },
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 标题icon
      titleIcon: '',
      // 任务列表
      taskList: [],
      // 主按钮名称
      btnName: '',
      // 是否有可看的视频
      hasActive: false,
      // 视频红包基础信息
      baseInfo: {},
      // 翻倍广告信息
      doubleAdvInformation: null,
      // 当前激活的任务索引
      activeIdx: -1,
      // 视频任务完成错误
      videoFinishedError: false,
      // 是否加载完成
      loaded: false,
      // 副标题
      subTitle: '',
      // 红包任务实验ab
      abResult: 0,
      // 可配置副标题文本样式（统一常量）
      subtitleNormalStyle: SUBTITLE_NORMAL_STYLE,
      subtitleHighlightStyle: SUBTITLE_HIGHLIGHT_STYLE,
    };
  },
  watch: {
    signInModuleInfo: {
      handler(newVal) {
        if (newVal) {
          this.handleVideoRedPackeData(newVal, true);
        }
      },
      deep: true,
    },
  },
  methods: {
    moduleExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_adver_videoButton',
        contentId: 'platform_adver_videoButton',
        businessInfo: {},
      });
      if (this.taskList && this.taskList.length > 0) {
        // 模块曝光埋点
        SPM.moduleExpose({
          moduleId: 'Welfare_adver',
          contentId: 'Welfare_adver',
          businessInfo: {
            adverTestVersion: this.abResult,
          },
        });
      }
    },
    // 更新视频红包数据
    async updateVideoRedPackeData() {
      try {
        const { token } = await getTokenAndKey() || {};
        // 获取设备厂商标识（iOS/Android 统一处理）
        const brand = await getManufacturer();
        // 获取最新数据
        const { data = {} } = await getPureSignPopup({
          token,
          newWelfare: true,
          manufacturer: brand,
        }) || {};
        const isSuccess = this.handleVideoRedPackeData(data.moduleInfo);
        return { success: isSuccess };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('updateVideoRedPackeData => error', safeJsonStringify(error));
        return { success: false };
      }
    },
    // 视频红包数据处理
    handleVideoRedPackeData(data, isFirst = false) {
      const {
        titleIcon,
        hasActive,
        btnName,
        taskList = [],
        baseInfo,
        curActiveIdx,
        doubleAdvInformation = null,
        subTitle,
        abResult,
      } = videoRedPacketDataAdapter(data) || {};
      this.taskList = taskList;
      this.titleIcon = titleIcon;
      this.btnName = btnName;
      this.hasActive = hasActive;
      this.baseInfo = baseInfo;
      this.doubleAdvInformation = doubleAdvInformation;
      this.subTitle = subTitle;
      this.loaded = true;
      this.abResult = abResult;

      // 将高亮的视频红包滚动到中间位置
      this.$nextTick(() => {
        const { videoRedPacketItem, videoRedPacketList } = this.$refs || {};
        if (!videoRedPacketItem || !videoRedPacketList) return;
        if (curActiveIdx !== -1) {
          scrollToLeft(
            this.$refs.videoRedPacketItem[curActiveIdx],
            this.$refs.videoRedPacketList,
            -12,
          );
        }
      });
      // 判断视频完成后任务是否推进成功
      if (!isFirst && curActiveIdx !== -1) {
        return curActiveIdx > this.activeIdx;
      }
      return true;
    },
    // 处理视频红包点击事件
    handleItemClick(item) {
      const { finished, curActive } = item || {};
      if (finished) return;
      // 加载视频广告弹窗
      this.loadAndShowVideo({
        clickType: curActive ? '2' : '3',
      });
    },
    // 处理主按钮点击事件
    handleMainBtnClick() {
      if (!this.hasActive) return;
      // 加载视频广告弹窗
      this.loadAndShowVideo({ clickType: '1' });
    },

    // 加载&展示视频广告 （新版逻辑，使用连续看视频引擎）
    async loadAndShowVideoNew() {
      const { unitId, taskCode } = this.baseInfo || {};
      let loadErrorInfo = null;
      let isCatchError = '';

      // 查找当前激活的任务
      const activeIdx = this.taskList.findIndex((item) => item.curActive);
      if (activeIdx === -1) {
        return { isCatchError: '', loadErrorInfo: null };
      }
      const activeItem = this.taskList[activeIdx];
      this.activeIdx = activeIdx;

      try {
        Loading.show();
        const result = await playContinuousVideo({
          firstVideoParams: {
            adUnitId: unitId,
            taskCode,
            rewardCount: activeItem.amount,
          },
          getNextVideoParams: ({ currentIndex }) => {
            // 基于 activeIdx + currentIndex 顺序取下一个
            const nextIdx = activeIdx + currentIndex + 1;
            if (nextIdx >= this.taskList.length) return null;
            const nextItem = this.taskList[nextIdx];
            return {
              adUnitId: unitId,
              taskCode,
              rewardCount: nextItem.amount,
            };
          },
          bannerAdsInfo: this.abResult === RED_PACKET_AB.newVersionWithBanner
            ? processAdParams(this.doubleAdvInformation || {})
            : {},
          toastConfig: {
            none_completed_failed: '网络数据不稳定，请稍后重试',
            none_completed_closed: '任务未完成',
            mid_video_failed: '网络数据不稳定，请稍后重试',
            mid_video_closed: '任务未完成',
          },
          callbacks: {
            onPopupExpose: ({ bannerAdsInfo: bInfo }) => {
              SPM.moduleExpose({
                moduleId: 'Welfare_jilishipinpop',
                contentId: 'Welfare_jilishipinpop',
                businessInfo: {
                  adverTestVersion: this.abResult,
                  adv: (bInfo && bInfo.adUnitId && bInfo.rewardCount) ? '0' : '1',
                },
              });
            },
            onAction: ({ action }) => {
              const buttonMap = {
                nextVideo: 'Welfare_jilishipinpop_next',
                bannerReward: 'Welfare_jilishipinpop_adv',
                videoBannerReward: 'Welfare_jilishipinpop_adv',
                close: 'Welfare_jilishipinpop_close',
              };
              if (buttonMap[action]) {
                SPM.clickButton({
                  buttonName: buttonMap[action],
                  businessInfo: {
                    adverTestVersion: this.abResult,
                  },
                });
              }
            },
            onSessionEnd: () => {
              Loading.close();
              this.updateVideoRedPackeData();
            },
          },
          finishTaskInfo: this.doubleAdvInformation.bannerTaskRelationCouponInfo,
        });

        // 处理引擎返回结果
        if (result && result.adLoadFailed && result.completedCount === 0) {
          isCatchError = '0';
          loadErrorInfo = result;
        }
        Loading.close();
      } catch (error) {
        Loading.close();
        // eslint-disable-next-line no-console
        console.error('loadAndShowVideoNew => error', safeJsonStringify(error));
        Toast.show('网络数据不稳定，请稍后重试');
        isCatchError = '1';
        loadErrorInfo = error || {};
        this.updateVideoRedPackeData();
      }

      return { isCatchError, loadErrorInfo };
    },
    // 加载&展示视频广告 （历史逻辑）
    async loadAndShowVideoOld() {
      const { unitId, taskCode } = this.baseInfo || {};
      let loadErrorInfo = null;
      let isCatchError = '';
      let toastErrStr = '';
      // 查找当前激活的任务
      const activeIdx = this.taskList.findIndex((item) => item.curActive);
      const activeItem = this.taskList[activeIdx];
      const { amount } = activeItem || {};
      this.activeIdx = activeIdx;

      try {
        Loading.show();
        // 1.加载广告视频
        const loadRes = await loadPlatformAds({
          pageName: 'rewardVideo',
          timeout: '5',
          scene: 'rebateBonus',
          adsource: ParamsUtil.getParams().adsource || '',
          adsInfo: {
            adUnitId: unitId,
            rewardCount: amount,
            taskCode,
            business_line: 'mars',
          },
        });

        if (loadRes && loadRes.pageId) {
          Loading.close();
          // 2.播放广告视频
          const showRes = await showPlatformAds({
            pageId: loadRes.pageId,
          });
          const { errCode, inspireType } = showRes || {};
          if (errCode) {
            Toast.show('任务未完成');
            return { isCatchError, loadErrorInfo };
          }

          // 3.推进任务完成
          const { success } = await handleFinishTask({
            inspireType,
            bannerTaskRelationCouponInfo: this.baseInfo,
          });
          if (!success) {
            return { isCatchError, loadErrorInfo };
          }

          // 4.加载奖励发放弹窗
          this.handleLoadRewardPopup();

          // 5.更新视频红包列表数据（弹窗展示后再刷新，避免 taskList 被清空）
          this.updateVideoRedPackeData();
        } else {
          Loading.close();
          toastErrStr = '网络数据不稳定，请稍后重试';
          Toast.show(toastErrStr);
          isCatchError = '0';
          loadErrorInfo = loadRes || {};
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('loadAndShowVideo => error', safeJsonStringify(error));
        toastErrStr = '网络数据不稳定，请稍后重试';
        Toast.show(toastErrStr);
        Loading.close();
        isCatchError = '1';
        loadErrorInfo = error || {};
      }
      return { isCatchError, loadErrorInfo };
    },

    // 加载&展示视频广告（调度入口）
    async loadAndShowVideo(options) {
      // 点击类型 1-看视频 2-观看 3-红包
      const { clickType } = options || {};
      let isCatchError = '';
      let loadErrorInfo = null;
      const result = this.abResult !== RED_PACKET_AB.oldVersion
        ? await this.loadAndShowVideoNew()
        : await this.loadAndShowVideoOld();
      if (result) {
        isCatchError = result.isCatchError;
        loadErrorInfo = result.loadErrorInfo;
      }

      // 点击埋点上报
      SPM.clickButton({
        buttonName: 'Welfare_adver',
        businessInfo: {
          clickarea: clickType,
          ladderIndex: String(this.activeIdx + 1),
        },
      });

      // 视频加载错误埋点上报
      if (isCatchError) {
        const { taskCode: errTaskCode, taskName: errTaskName } = this.baseInfo || {};
        SPM.customEventWithPointId({
          pointId: 'apmError_videoLoadError',
          businessInfo: {
            error: '网络数据不稳定，请稍后重试',
            task_name: errTaskName || '',
            taskid: errTaskCode || '',
            isCatchError,
            errorInfo: safeJsonStringify(loadErrorInfo),
          },
        });
      }
    },
    // 加载奖励发放弹窗
    async handleLoadRewardPopup() {
      let isEnd = true;
      let curItem = {};
      let nextItem = {};

      // 判断当前激活的任务索引存在，则获取当前任务和下一个任务
      if (this.activeIdx !== -1) {
        isEnd = this.activeIdx === this.taskList.length - 1;
        curItem = this.taskList[this.activeIdx] || {};
        nextItem = this.taskList[this.activeIdx + 1] || {};
      }

      // 获取当前埋点公共参数
      const getTrackInfo = () => ({
        adverTestVersion: this.abResult,
        impids: this.baseInfo?.unitId || '',
        taskid: this.baseInfo?.taskCode || '',
        task_id: this.baseInfo?.taskCode || '',
        ladderIndex: String(this.activeIdx + 1),
        advScene: ADV_SCENE.VIDEO_RED_PACKET,
        advSceneDetail: String(this.activeIdx + 1),
      });

      Loading.show();
      // 获取弹窗广告信息
      const adsInfo = processAdParams(this.doubleAdvInformation || {});
      // 弹窗参数
      const params = {
        pageName: 'rewardResult',
        timeout: '2',
        scene: 'rebateBonus',
        adsource: ParamsUtil.getParams().adsource || '',
        adsInfo,
        otherInfo: {
          data: {
            isEnd,
            rewardCount: curItem.amount || '',
            nextRewardCount: nextItem.amount || '',
          },
        },
      };
      // eslint-disable-next-line no-console
      console.log('handleLoadRewardPopup => params', safeJsonStringify(params));
      // 加载弹窗
      const loadRes = await loadPlatformAds(params);
      const { bannerTaskRelationCouponInfo } = this.doubleAdvInformation || {};
      this.doubleAdvInformation = null;
      if (loadRes && loadRes.pageId) {
        Loading.close();
        // 播放金币收起动画
        eventBus.$emit('playCollectAnimate');

        // 激励视频发奖弹窗曝光埋点
        trackRewardPopupExpose({
          ...getTrackInfo(),
          adv: adsInfo.adUnitId && adsInfo.rewardCount ? '0' : '1',
        });

        // 展示弹窗
        const showRes = await showPlatformAds({
          pageId: loadRes.pageId,
        });
        const {
          inspireType,
          action,
          adsInfo: { rewardTotalCount = '' } = {},
        } = showRes || {};
        switch (action) {
          // 下一个视频
          case 'nextVideo':
            this.loadAndShowVideo();
            trackNextVideo(getTrackInfo());
            break;
          // 翻倍视频广告
          case 'videoBannerReward':
            this.handleBannerReward({
              inspireType,
              bannerTaskRelationCouponInfo,
              isEnd,
              rewardTotalCount,
              nextItem,
            });
            trackAdvClick(getTrackInfo());
            break;
          // 翻倍banner广告
          case 'bannerReward':
            this.handleBannerReward({
              inspireType,
              bannerTaskRelationCouponInfo,
              isEnd,
              rewardTotalCount,
              nextItem,
            });
            trackAdvClick(getTrackInfo());
            break;
          // 关闭弹窗
          case 'close':
            trackPopupClose(getTrackInfo());
            break;
          default:
            break;
        }
      }
      Loading.close();
    },
    // 处理翻倍广告奖励
    async handleBannerReward({
      inspireType, bannerTaskRelationCouponInfo, isEnd, rewardTotalCount, nextItem,
    }) {
      const result = await loadRewardResultPlatformAds({
        inspireType,
        bannerTaskRelationCouponInfo,
        otherInfo: {
          data: {
            isEnd,
            rewardCount: rewardTotalCount,
            nextRewardCount: nextItem.amount || '',
            isTotalReward: true,
          },
        },
      });
      const { action } = result || {};
      if (action === 'nextVideo') {
        this.loadAndShowVideo();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.video-red-packet-container {
  background-color: #fff;
  border-radius: 0.16rem;
  padding-bottom: 0.15rem;

  .video-red-packet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.13rem 0.12rem 0;

    .header-left {
      display: flex;
      align-items: center;
      max-width: 2.57rem;
    }
  }

  .video-red-packet-title {
    margin-right: 0.08rem;
    font-weight: 600;
    font-size: 0.15rem;
    line-height: 0.21rem;
    color: #242729;
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .video-red-packet-desc {
    display: flex;
    align-items: center;
    flex: 0 1 auto;
    min-width: 0;

    .bounty-icon {
      flex: none;
      margin-right: 0.02rem;
      width: 0.16rem;
      height: 0.16rem;
    }

    .bounty-desc {
      // 颜色仅用于省略号（…），文本本身的颜色由 HighlightText 的内联样式控制
      font-size: 0.12rem;
      line-height: normal;
      color: #5a6066;
      flex: 0 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .video-red-packet-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.62rem;
    height: 0.28rem;
    border-radius: 1rem;
    background-color: #ffe888;
    line-height: normal;
    font-weight: 500;
    font-size: 0.12rem;
    color: #000;

    &.video-red-packet-btn-disabled {
      background-color: #cfcfcf;
      color: #fff;
    }
  }

  .header-subTitle {
    margin: 0 0.12rem 0.12rem 0.12rem;
    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.14rem;
    color: #5a6066;
    flex-wrap: nowrap;
  }

  .video-red-packet-content {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 0 0.12rem 0;
    height: 0.65rem;

    &::-webkit-scrollbar {
      display: none;
    }

    .video-red-packet-item {
      display: flex;
      justify-content: center;
      flex-shrink: 0;
      margin-right: 0.1rem;
      width: 0.48rem;
      height: 0.57rem;
      background-image: url('https://m.hellobike.com/099164b60e.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;

      &:last-child {
        margin-right: 0;
      }

      .video-red-packet-item-num {
        margin-top: 0.28rem;
        font-family: 'DIN Alternate Bold', sans-serif;
        font-size: 0.16rem;
        line-height: 0.22rem;
        color: #fff8cb;
      }

      &.active {
        position: relative;
        overflow: hidden;
        width: 0.58rem;
        height: 0.65rem;
        background-image: url('https://m.hellobike.com/ea522873a0.png');

        .video-red-packet-item-num {
          margin-top: 0.04rem;
          font-size: 0.22rem;
          line-height: 0.27rem;
          color: #ff3e36;
        }

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 60%;
          height: 100%;
          background:
            linear-gradient(
              to right,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 243, 202, 0.5) 50%,
              rgba(255, 255, 255, 0) 100%
            );
          transform: skewX(-45deg);
          animation: scan 1.5s ease-in-out infinite;
        }

        @keyframes scan {
          0% {
            left: -120%;
          }

          100% {
            left: 180%;
          }
        }
      }

      &.disabled {
        width: 0.48rem;
        height: 0.55rem;
        background-image: url('https://m.hellobike.com/62efa7cbac.png');
      }
    }
  }
}
</style>
